import { useMutation } from '@tanstack/react-query';
import api from '../../services/axios';
import { Template } from '../../types/template';
import { useNavigate } from 'react-router-dom';

interface CreateTemplateData {
    name: string;
    config: Template['config'];
}

export const useCreateTemplate = () => {
    const navigate = useNavigate();

    return useMutation({
        mutationFn: (data: CreateTemplateData) =>
            api.post<Template>('/settings-app/templates', data).then(res => res.data),
        onSuccess: () => {
            navigate('/dashboard/templates');
        }
    });
};